import { useTranslation } from 'react-i18next';

import {
  checkInternationalPhone,
  checkInternationalPhoneRequired,
  checkMaxLength,
  checkSpace,
} from '@portalCommon/utils';
import { Col, Form, Input, Row } from '@fuxi/eevee-ui';

import type { FormInstance } from 'antd/es/form';
import { CountryPhoneFieldFormItem } from '@commonPackage/components';
import classnames from 'classnames/bind';
import styles from './index.module.less';

const cx = classnames.bind(styles);
interface Props {
  isAgent?: boolean;
  isContactSuccess: boolean | undefined;
  form?: FormInstance<any>;
}

const ContactFormItems = ({ isAgent, isContactSuccess, form }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={isAgent ? [40, 24] : 24}>
        <Col span={12}>
          <Form.Item
            label={t('consultForm.name')}
            name="name"
            required
            validateFirst
            rules={[
              {
                required: true,
                message: t('consultForm.nameValidator'),
              },
              {
                validator: checkSpace(t('consultForm.nameValidator')),
              },
              {
                validator: checkMaxLength(30, t('consultForm.nameLenValid')),
              },
            ]}>
            <Input style={{ height: 40 }} placeholder={t('consultForm.namePlaceHolder')} autoComplete="off" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <CountryPhoneFieldFormItem
            labelName={t('consultForm.tel')}
            validateTrigger={[]}
            className={cx('portal-country-phone-wrapper')}
            form={form}
            placeholder={t('consultForm.telPlaceHolder')}
            rules={[
              {
                validator: checkInternationalPhoneRequired(t('consultForm.telValidator')),
              },
              {
                validator: checkInternationalPhone(true, t('consultForm.telValidFormat')),
              },
            ]}
          />
        </Col>
      </Row>
      <Row gutter={isAgent ? [40, 24] : 24}>
        <Col span={12}>
          <Form.Item
            label={t('consultForm.org')}
            name="orga_name"
            required
            validateFirst
            rules={[
              {
                required: true,
                message: t('consultForm.orgValidator'),
              },
              {
                validator: checkSpace(t('consultForm.orgValidator')),
              },
              {
                validator: checkMaxLength(50, t('consultForm.orgLenValid')),
              },
            ]}>
            <Input style={{ height: 40 }} placeholder={t('consultForm.orgPlaceHolder')} autoComplete="off" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={t('consultForm.position')}
            name="title"
            validateFirst
            rules={
              isAgent
                ? []
                : [
                    {
                      validator: checkMaxLength(50, t('consultForm.titleLenValid')),
                    },
                  ]
            }>
            <Input style={{ height: 40 }} placeholder={t('consultForm.posPlaceHolder')} autoComplete="off" />
          </Form.Item>
        </Col>
      </Row>
      {isAgent && (
        <Form.Item label={t('agentApply.desc')} name="agentContent">
          <Input.TextArea
            allowClear
            placeholder={t('agentApply.descPlaceHolder')}
            autoSize={{ minRows: 3 }}
            maxLength={500}
            showCount
          />
        </Form.Item>
      )}
    </>
  );
};

export default ContactFormItems;
